export default __webpack_public_path__ + "static/media/squre.a416ba76.svg";